import Vue from 'vue'
import Dialog from './index.vue'

let instance = null

// 创建实例
function initInstance(propsData) {
  const Instance = Vue.extend(Dialog)
  instance = new Instance({
    propsData,
    el: document.createElement('div')
  })
}

// 打开对话框
function showDialog() {
  instance.dialogVisible = true
  document.body.appendChild(instance.$el)
}

export default function (opstions = {}) {
  const propsData = opstions

  if (!instance) {
    initInstance(propsData)
  }

  showDialog()

  return new Promise((resolve, reject) => {
    // 这里通过重新定义 instance callback 变量的方式，来 触发 resolve 和 reject
    instance.callback = action => {
      if (action === 'ok') {
        resolve()
      } else {
        reject()
      }
      setTimeout(() => {
        instance.$destroy()
        instance = null
      })
    }
  })
}
